<!--
  - Copyright (c) 2008-2021 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
  - This is CONFIDENTIAL code. Use is subject to license terms.
  -->
<template>
  <span>
    <icon v-if="html" :icon="['fas', 'info-circle']" class="text-primary cursor-pointer" v-tooltip.html="text"></icon>
    <icon v-else :icon="['fas', 'info-circle']" class="text-primary cursor-pointer" v-tooltip="text"></icon>
  </span>
</template>

<script>
export default {
  name: "TooltipIcon",

  props: {
    text: { type: String, default: "" },
    html: { type: Boolean, default: false },
  },
}
</script>
